
export class User {
	id				: 	number;
	username		: 	string; 
	email			:	string;
	password		: 	string;
	display_name	:	string;
	joined			:	string;
	status			:	string;
	avatar			:	string;
	role_id			:	string;
	signature_file	:	string;
	reminder		:	string;
	remember		:	string;
	subrole_id		: 	string;
	sub_role_name	: 	string;
	deleted_date	: 	string;
	created_by		: 	any;
	updated_by		: 	any;
}


export class Profile {
	id				: number;
	user_id			: number;
	first_name		: string;
	middle_name		: string;
	last_name		: string;
	gender			: number;
	birthdate		: string;
	mobile_no		: string;
	phone_no		: string;
	address			: string;
	address_lat		: string;
	address_lng		: string;
}

export class Account {
	id				: 	number;
   	username		: 	string; 
   	email			:	string;
}


export class Password {
	id	: number;
	old_password	: string;
	confirm_password: string;
	new_password	: string;
}


export class ThemeSetting {
	id	: number;
	theme	: string;
	menu: string;
	menu_type	: string;
	is_navbar_fixed: number;
	is_sidebar_fixed: number;
	is_footer_fixed: number;
}


export class Url {
	app: string;
	rest: string;
	fileStorage: string;
	cloudStorage: string;
}

export class Log {
	text: string;
}

export class UserFile {
	id					: number;
	user_id				: number;
	verified			: number;
	is_viewable			: number;
	induction_task_id	: number;
	filename			: string;
	expiry				: string;
	description			: string;
	date_added			: string;
	created_by			: number;
	updated_by			: number;
	induction_record_id  : number;
}